import { Routes } from '@angular/router';
import { authGuard, signedOutGuard } from './core/auth/auth.guard';
import { CALLBACK_ROUTE } from './core/util/sign-in';
import { ShellComponent } from './layout/shell.component';

export const routes: Routes = [
  {
    path: 'sign-in',
    canActivate: [signedOutGuard],
    title: 'Sign in · Vetta',
    loadComponent: () => import('./features/sign-in/sign-in.page').then((m) => m.SignInPage),
  },
  {
    path: CALLBACK_ROUTE,
    title: 'Signing in · Vetta',
    loadComponent: () => import('./features/auth-callback/auth-callback.page').then((m) => m.AuthCallbackPage),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'companies' },
      {
        path: 'companies',
        title: 'Companies · Vetta',
        loadComponent: () => import('./features/companies/companies.page').then((m) => m.CompaniesPage),
      },
      {
        path: 'companies/:companyId',
        title: 'Company · Vetta',
        loadComponent: () => import('./features/company/company.page').then((m) => m.CompanyPage),
      },
      {
        path: 'companies/:companyId/jobs/:jobShortCode',
        title: 'Smart JD · Vetta',
        loadComponent: () => import('./features/smart-jd/smart-jd.page').then((m) => m.SmartJdPage),
      },
      {
        path: 'companies/:companyId/jobs/:jobShortCode/matches',
        title: 'Matches · Vetta',
        loadComponent: () => import('./features/matches/matches.page').then((m) => m.MatchesPage),
      },
      {
        path: 'companies/:companyId/jobs/:jobShortCode/matches/:candidateId',
        title: 'Candidate · Vetta',
        loadComponent: () => import('./features/candidate/candidate.page').then((m) => m.CandidatePage),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
